import { render, staticRenderFns } from "./licensing.vue?vue&type=template&id=5aba0904&scoped=true&lang=pug"
import script from "./licensing.vue?vue&type=script&lang=js"
export * from "./licensing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba0904",
  null
  
)

/* custom blocks */
import block0 from "./licensing.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports